var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.assets),function(asset,i){return _c('span',{key:asset.link},[_c('MarkedLink',{attrs:{"href":asset.link,"level":_vm.level,"is-text":_vm.isText}},[_vm._v(_vm._s(asset.title))]),(+i < _vm.assets.length - 1 && _vm.isText)?_c('el-divider',{attrs:{"direction":"vertical"}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }